import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    paymentAccount: {
      name: 'รหัสบัญชี',
      width: '5rem',
      // eslint-disable-next-line
      filter: (val: any) => val?.code ? val?.code : '',
    },
    cashFlow: {
      name: 'ประเภทบัญชี',
      width: '6rem',
    },
    name: {
      name: 'รายการ',
      width: '1fr',
    },
    // income: {
    //   name: 'รายรับ',
    //   width: '6rem',
    // },
    expense: {
      name: 'รายจ่าย',
      width: '6rem',
    },
    type: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string) => {
        if (val === 'EXPENSE') return 'รายจ่าย';
        if (val === 'INCOME') return 'รายรับ';
        return 'NA';
      },
    },
    date: {
      name: 'วันที่',
      width: '8rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    deliveryNote: {
      name: 'รายการขนส่ง',
      width: '8rem',
    },
    driver: {
      name: 'คนขับรถ',
      width: '8rem',
    },
    vehicle: {
      name: 'รถขนส่ง',
      width: '8rem',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: string) => {
        if (val === 'PAID') return 'ชำระแล้ว';
        if (val === 'UNPAID') return 'ค้างชำระ';
        if (val === 'CANCELLED') return 'ยกเลิก';
        return '';
      },
    },
  },
};
